import React from 'react'
import styled from 'styled-components'
import useApp from './use-app-context.js'
import site from '../../data/site.mjs'
import theme from './theme.js'
import Link from './link.js'

const UnstyledNavTitle = ({
  className
}) => {
  const app = useApp()
  const title = site.title

  const props = {
    className 
  }

  return (
    <h1 {...props}>
      <Link to='/'>{title}</Link>
    </h1>
  )
}

const NavTitle = styled(UnstyledNavTitle)`
  font-size: ${theme.font.size.h4};
  font-family: ${theme.font.family.primary};
`

export default NavTitle